module.exports = __webpack_public_path__ + "img/VIP-4.4af34db7.png";